// extracted by mini-css-extract-plugin
export default {"editButton":"Item_editButton__Vt7BG","labelButton":"Item_labelButton__GkTK6","labelButtonActive":"Item_labelButtonActive__ZY4Gr","wrapper":"Item_wrapper__xKBUd"};